export const billingToken =
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJtYXJjYSI6Ik5PUk1BTElaQVJfRElSIiwic2VnbWVudG8iOiJSRVMiLCJjYW5hbCI6InNmZGMifQ.cmiqOPvdmcNsP5SPQywgVav8qMwxty6vbtlNyhbbsq8'
export const vista360Token =
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJtYXJjYSI6IllPSUdPIiwic2VnbWVudG8iOiJSRVMiLCJjYW5hbCI6InRlbGVzYWxlc18zNjAifQ.BX7IiN4IUHkd8JSQ6jBsh1ipN0B75aADaerDeDI8Hvk'
export const salesToken =
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJtYXJjYSI6IkxFQUQiLCJzZWdtZW50byI6IlJFUyIsImNhbmFsIjoiTEVBRCJ9.GDrHcvSg5p3azdetza1g7qOD-mBH0jnyOro2PVeY394'
